export const MONTHLY_MAINTENANCE_FEE_POINTS = 100;
